import React, { useEffect } from "react";
import {
  MobileOrdersContainer,
  MobileOrderCard,
  MobileCardRow,
  MobileCardLabel,
  MobileCardValue,
  MobileCardStatus,
} from "../styles/Layoutstyle";
import MobileDateFilters from "./MobileDateFilters";

const MobileOrders = ({
  orders,
  loading,
  isSearching,
  searchResults,
  searchTerm,
  formatDate,
  dateFilters,
  onDateFilterChange,
  availableStatuses,
  setPagination,
  onStatusFilterChange,
  isDarkMode,
}) => {
  useEffect(() => {
    setPagination({
      total: 0,
      totalPages: 0,
      page: 1,
      pageSize: 20,
    });
  }, []);

  const renderMobileOrderCard = (order) => (
    <MobileOrderCard
      key={order.id || order.orderId}
      status={order.status}
      data-status={order.status?.toLowerCase()}
      isDarkMode={isDarkMode}
    >
      <MobileCardRow>
        <MobileCardLabel isDarkMode={isDarkMode}>Order ID:</MobileCardLabel>
        <MobileCardValue isDarkMode={isDarkMode}>{order.orderId}</MobileCardValue>
      </MobileCardRow>
      <MobileCardRow>
        <MobileCardLabel isDarkMode={isDarkMode}>Order Date:</MobileCardLabel>
        <MobileCardValue isDarkMode={isDarkMode}>
          {formatDate(order.created_date)?.split(", ").slice(0, 2).join(", ") ||
            "—"}
        </MobileCardValue>
      </MobileCardRow>
      <MobileCardRow>
        <MobileCardLabel isDarkMode={isDarkMode}>Status:</MobileCardLabel>
        <MobileCardStatus status={order.status}>
          {order.status
            ?.replace(/[_-]/g, " ")
            .replace(/\b\w/g, (m) => m.toUpperCase())}
        </MobileCardStatus>
      </MobileCardRow>
      <MobileCardRow>
        <MobileCardLabel isDarkMode={isDarkMode}>EOS Status:</MobileCardLabel>
        <MobileCardValue isDarkMode={isDarkMode}>{order.eosStatus || "N/A"}</MobileCardValue>
      </MobileCardRow>
      <MobileCardRow>
        <MobileCardLabel isDarkMode={isDarkMode}>Street View Required:</MobileCardLabel>
        <MobileCardValue isDarkMode={isDarkMode}>
          {order.streetViewRequired ? "✅ Yes" : "❌ No"}
        </MobileCardValue>
      </MobileCardRow>
      <MobileCardRow>
        <MobileCardLabel isDarkMode={isDarkMode}>Accuzip ID:</MobileCardLabel>
        <MobileCardValue isDarkMode={isDarkMode}>{order.accuzipNumber}</MobileCardValue>
      </MobileCardRow>
      <MobileCardRow>
        <MobileCardLabel isDarkMode={isDarkMode}>Accuzip Start Time:</MobileCardLabel>
        <MobileCardValue isDarkMode={isDarkMode}>
          {formatDate(order.accuzip_startTime)
            ?.split(", ")
            .slice(0, 3)
            .join(", ") || "—"}
        </MobileCardValue>
      </MobileCardRow>
      <MobileCardRow>
        <MobileCardLabel isDarkMode={isDarkMode}>Accuzip End Time:</MobileCardLabel>
        <MobileCardValue isDarkMode={isDarkMode}>
          {formatDate(order.accuzip_endTime)
            ?.split(", ")
            .slice(0, 3)
            .join(", ") || "—"}
        </MobileCardValue>
      </MobileCardRow>
      <MobileCardRow>
        <MobileCardLabel isDarkMode={isDarkMode}>Total:</MobileCardLabel>
        <MobileCardValue isDarkMode={isDarkMode}>{order.total || "N/A"}</MobileCardValue>
      </MobileCardRow>
      <MobileCardRow>
        <MobileCardLabel isDarkMode={isDarkMode}>Street View Completed:</MobileCardLabel>
        <MobileCardValue isDarkMode={isDarkMode}>
          {!order.streetViewRequired
            ? "N/A"
            : order.streetViewCompleted
              ? "✅ Yes"
              : "❌ No"}
        </MobileCardValue>
      </MobileCardRow>
      <MobileCardRow>
        <MobileCardLabel isDarkMode={isDarkMode}>Completion Date:</MobileCardLabel>
        <MobileCardValue isDarkMode={isDarkMode}>
          {!order.streetViewRequired
            ? "N/A"
            : formatDate(order.streetViewCompletionDate)}
        </MobileCardValue>
      </MobileCardRow>
    </MobileOrderCard>
  );

  const dataToRender = isSearching ? searchResults : orders;
  const isEmpty = dataToRender.length === 0;

  if (loading) {
    return (
      <MobileOrdersContainer>
        {onDateFilterChange && (
          <div style={{ padding: "1rem 1rem 0", marginBottom: "1rem" }}>
            <MobileDateFilters
              availableStatuses={availableStatuses}
              dateFilters={dateFilters}
              onDateFilterChange={onDateFilterChange}
              onStatusFilterChange={onStatusFilterChange}
              isDarkMode={isDarkMode}
            />
          </div>
        )}
        <div style={{ padding: "1rem" }}>
          {Array(3)
            .fill()
            .map((_, index) => (
              <div
                key={`skeleton-${index}`}
                style={{
                  background: "white",
                  borderRadius: "8px",
                  padding: "1rem",
                  marginBottom: "1rem",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                  borderLeft: "4px solid #e0e0e0",
                }}
              >
                <div
                  style={{
                    height: "16px",
                    background: "#f0f0f0",
                    borderRadius: "4px",
                    marginBottom: "0.5rem",
                  }}
                ></div>
                <div
                  style={{
                    height: "16px",
                    background: "#f0f0f0",
                    borderRadius: "4px",
                    marginBottom: "0.5rem",
                    width: "60%",
                  }}
                ></div>
                <div
                  style={{
                    height: "16px",
                    background: "#f0f0f0",
                    borderRadius: "4px",
                    width: "40%",
                  }}
                ></div>
              </div>
            ))}
        </div>
      </MobileOrdersContainer>
    );
  }

  return (
    <MobileOrdersContainer>
      {onDateFilterChange && (
        <div style={{ marginBottom: "1rem" }}>
          <MobileDateFilters
            availableStatuses={availableStatuses}
            dateFilters={dateFilters}
            onDateFilterChange={onDateFilterChange}
            onStatusFilterChange={onStatusFilterChange}
            isDarkMode={isDarkMode}
          />
        </div>
      )}
      {isEmpty ? (
        <div
          style={{
            textAlign: "center",
            padding: "2rem",
            color: "#666",
            background: "white",
            borderRadius: "8px",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
          }}
        >
          {isSearching
            ? `No orders found matching "${searchTerm}"`
            : "No orders found"}
        </div>
      ) : (
        dataToRender.map(renderMobileOrderCard)
      )}
    </MobileOrdersContainer>
  );
};

export default MobileOrders;
